import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'sbnb-add-task-rule-flow-confirm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-task-rule-flow-confirm.component.html',
})
export class AddTaskRuleFlowConfirmComponent {
  turnoIntegrationEnabled = input<boolean>(false);
  cleansterIntegrationEnabled = input<boolean>(false);
  resortCleaningIntegrationEnabled = input<boolean>(false);
  tidyIntegrationEnabled = input<boolean>(false);

  activeIntegrations() {
    return [
      {
        name: 'Turno',
        enabled: this.turnoIntegrationEnabled(),
      },
      {
        name: 'Cleanster',
        enabled: this.cleansterIntegrationEnabled(),
      },
      {
        name: 'Resort Cleaning',
        enabled: this.resortCleaningIntegrationEnabled(),
      },
      {
        name: 'TIDY',
        enabled: this.tidyIntegrationEnabled(),
      },
    ]
      .filter((integration) => integration.enabled)
      .map((integration) => integration.name)
      .join(', ');
  }
}
